import { RegistrationState } from "./RegistrationState";
import { RegStateRedirect } from "./RegStateRedirect";

/** Etat : Traitement de l'expiration du token */
export class RegStateErrorExpired extends RegistrationState {
    public async Next(): Promise<void> {

        /** Affiche l'érreur */
        this.context.ShowError = true;

        this.context.TransitionTo(new RegStateRedirect(this))
        await this.context.Next();
    }
}